import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import React from "react";

type Props = {
  question: string | JSX.Element;
  answer: string | JSX.Element;
  defaultOpen?: boolean;
};

export const FaqItem: React.FC<Props> = ({ question, answer, defaultOpen }) => {
  return (
    <Accordion defaultExpanded={defaultOpen} className="px-2">
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography>{question}</Typography>
      </AccordionSummary>
      <AccordionDetails className="pb-4">
        <Typography>{answer}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};
